import { siteConfig } from "@/config/site";

// Infinite scrolling strip of typographic tire brand names.
// Brands are edited in src/config/site.js -> tireBrands.
export const BrandMarquee = () => {
  const brands = siteConfig.tireBrands;
  const items = [...brands, ...brands];
  return (
    <div data-testid="brand-marquee" className="relative overflow-hidden border-y border-white/10 py-6 md:py-8 brand-marquee">
      <div className="brand-marquee-track">
        {items.map((b, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span
              data-testid={i < brands.length ? `brand-${b.toLowerCase()}` : undefined}
              className="font-display font-bold tracking-[0.08em] text-white text-3xl md:text-5xl px-6 md:px-10 hover:text-[var(--accent)] transition-colors"
            >
              {b.toUpperCase()}
            </span>
            <span className="h-2 w-2 rotate-45 shrink-0" style={{ background: "var(--accent)" }} />
          </div>
        ))}
      </div>
    </div>
  );
};
